<form
  [formGroup]="personalInfoForm"
  [ngClass]="{ submitted: formSubmitted }"
  (keydown.enter)="enter($event)"
  >
  <div>
    <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
      <div
        fxLayout="col"
        fxFlex="100"
        class="add-patient-col"
        fxLayoutAlign="start center"
        >
        {{ "Upload" | translate
        }}<span class="optional">{{ "(optional)" | translate }}</span>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
      <div
        fxLayout="col"
        fxFlex="100"
        class="add-patient-profile"
        fxLayoutAlign="start center"
        >
        <div style="margin-right: 20px">
          <nz-avatar
            [nzShape]="'circle'"
            [nzSize]="100"
            [nzIcon]="'user'"
            [nzSrc]="avatarImageUrl"
          ></nz-avatar>
        </div>
        <button
          nz-button
          nzType="primary"
          [ngClass]="'upload-patient-picture-btn avatar-button-bottom-right'"
          (click)="uploadAndOpenImageCropper()"
          >
          <i nz-icon nzType="icons:uploadProfile" style="font-size: 12px"></i>
        </button>

        <!-- Delete Button -->
        @if (avatarImageUrl) {
          <button
            nz-button
            nzType="primary"
            [ngClass]="'remove-patient-picture-btn avatar-button-bottom-right'"
            (click)="removeProfilePicture()"
            >
            <i nz-icon nzType="icons:deleteProfile" style="font-size: 12px"></i>
          </button>
        }
      </div>
    </div>
  </div>
  <!-- First Name and Last Name -->
  <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
    <div
      fxLayout="col"
      fxFlex="50"
      class="add-patient-col"
      fxLayoutAlign="start center"
      >
      {{ "First name" | translate }}
    </div>
    <div
      fxLayout="col"
      fxFlex="50"
      class="add-patient-col"
      fxLayoutAlign="start center"
      >
      {{ "Last name" | translate }}
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
    <div fxLayout="col" fxFlex="50" class="add-patient-col">
      <input
        type="text"
        class="add-patient-input"
        [placeholder]="'First name' | translate"
        formControlName="firstName"
        [maxLength]="51"
        pattern="[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]*"
        onkeypress="return /^[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]+$/i.test(event.key)"
        required
        />
      </div>
      <div fxLayout="col" fxFlex="50" class="add-patient-col">
        <input
          type="text"
          class="add-patient-input"
          [placeholder]="'Last name' | translate"
          formControlName="lastName"
          [maxLength]="51"
          pattern="[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]*"
          onkeypress="return /^[A-Za-zΑ-Ωα-ωΆ-Ώά-ώ]+$/i.test(event.key)"
          required
          />
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
        <div
          fxLayout="col"
          fxFlex="50"
          class="add-patient-col"
          fxLayoutAlign="start center"
          >
          {{ "Gender" | translate }}
        </div>
        <div
          fxLayout="col"
          fxFlex="50"
          class="add-patient-col"
          fxLayoutAlign="start center"
          >
          {{ "Date of birth" | translate }}
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
        <div fxLayout="col" fxFlex="50" class="add-patient-col">
          <nz-select
            (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
            class="add-patient-inputZorro"
            nzShowSearch
            [appTerminologySearch]="gendersList"
            nzAllowClear
            [nzPlaceHolder]="'Gender' | translate"
            formControlName="gender"
            >
            @for (gender of gendersList; track gender) {
              <nz-option
                nzLabel="{{ gender.name }}"
                nzValue="{{ gender.id }}"
              ></nz-option>
            }
          </nz-select>
        </div>
        <div fxLayout="col" fxFlex="50" class="add-patient-col">
          <input
            (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
            formControlName="dateOfBirth"
            class="add-patient-input"
            type="date"
            [min]="get1900Date()"
            [max]="getCurrentDate()"
            />
          </div>
        </div>

        <!-- Date of Birth and Place of Birth -->
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="50"
            class="add-patient-col"
            fxLayoutAlign="start center"
            >
            {{ "Place of Birth" | translate }}
            <span class="optional">{{ "(optional)" | translate }}</span>
          </div>
          <div
            fxLayout="col"
            fxFlex="50"
            class="add-patient-col"
            fxLayoutAlign="start center"
            >
            {{ "District of Birth" | translate }}
            <span class="optional">{{ "(optional)" | translate }}</span>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
          <div fxLayout="col" fxFlex="50" class="add-patient-col">
            <!-- Place of Birth Selector -->
            <nz-select
              (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
              class="add-patient-inputZorro"
              nzShowSearch
              [appTerminologySearch]="placeOfBirthList"
              nzAllowClear
              [nzPlaceHolder]="'Place of Birth' | translate"
              formControlName="placeOfBirthId"
              (ngModelChange)="onPlaceOfBirthChange($event)"
              >
              @for (place of placeOfBirthList; track place) {
                <nz-option [nzLabel]="place.name" [nzValue]="place.id"></nz-option>
              }
            </nz-select>
          </div>
          <div fxLayout="col" fxFlex="50" class="add-patient-col">
            <!-- Conditional rendering for District of Birth -->
            @if (!isPlaceOfBirthCyprus) {
              <!-- Text input if not Cyprus -->
              <input
                class="add-patient-input"
                [placeholder]="'District of Birth' | translate"
                formControlName="districtOfBirth"
                [maxLength]="51"
                />
              } @else {
                <nz-select
                  (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                  class="add-patient-inputZorro"
                  nzShowSearch
                  nzAllowClear
                  [nzPlaceHolder]="'Select a District' | translate"
                  formControlName="districtOfBirth"
                  [maxlength]="51"
                  >
                  @for (city of cyprusCities; track city) {
                    <nz-option
                      [nzLabel]="city | translate"
                      [nzValue]="city"
                    ></nz-option>
                  }
                </nz-select>
              }
              <!-- Dropdown if Cyprus -->
            </div>
          </div>

          <!-- Phone Number and Email Address -->
          <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Phone Number" | translate }}
              <span class="optional">{{ "(optional)" | translate }}</span>
            </div>
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
            ></div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              <ngx-intl-tel-input
                [cssClass]="'custom'"
                [preferredCountries]="[CountryISO.Cyprus, CountryISO.Greece]"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="false"
                [searchCountryFlag]="true"
        [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.Cyprus"
                [maxLength]="50"
                [phoneValidation]="true"
                [separateDialCode]="true"
                name="phone"
                formControlName="phone"
              ></ngx-intl-tel-input>
            </div>
            <div fxLayout="col" fxFlex="50" class="add-patient-col"></div>
          </div>

          <!--  Religion -->
          <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Religion" | translate }}
              <span class="optional">{{ "(optional)" | translate }}</span>
            </div>
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
            ></div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              <nz-select
                (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                class="add-patient-inputZorro"
                nzShowSearch
                nzAllowClear
                [nzPlaceHolder]="'Religion' | translate"
                formControlName="religionId"
                >
                @for (religion of religionList; track religion) {
                  <nz-option
                    nzLabel="{{ religion.name }}"
                    nzValue="{{ religion.id }}"
                  ></nz-option>
                }
              </nz-select>
              <!--
              Conditionally show the free text input.
              The value 26 is the  id of option "Other" in religion
              -->
              @if (personalInfoForm.get('religionId')?.value == 26) {
                <input
                  class="add-patient-input"
                  formControlName="religionOther"
                  placeholder="{{ 'Please specify' | translate }}"
                  [maxLength]="50"
                  />
              }
            </div>
            <div fxLayout="col" fxFlex="50" class="add-patient-col"></div>
          </div>

          <!-- Education Level and Occupation -->
          <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Education Level" | translate }}
              <span class="optional">{{ "(optional)" | translate }}</span>
            </div>
            <div
              fxLayout="col"
              fxFlex="50"
              class="add-patient-col"
              fxLayoutAlign="start center"
              >
              {{ "Occupation" | translate }}
              <span class="optional">{{ "(optional)" | translate }}</span>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              <nz-select
                (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                class="add-patient-inputZorro"
                nzShowSearch
                nzAllowClear
                [nzPlaceHolder]="'Education Level' | translate"
                formControlName="educationLevelId"
                >
                @for (education of educationLevelList; track education) {
                  <nz-option
                    nzLabel="{{ education.name }}"
                    nzValue="{{ education.id }}"
                  ></nz-option>
                }
              </nz-select>
              <!--
              Conditionally show the free text input.
              The value 5 is the  id of option "Other" in education level
              -->
              @if (personalInfoForm.get('educationLevelId')?.value == 5) {
                <input
                  class="add-patient-input"
                  formControlName="educationLevelOther"
                  placeholder="{{ 'Please specify' | translate }}"
                  [maxLength]="50"
                  />
              }
            </div>
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              <input
                class="add-patient-input"
                [placeholder]="'Occupation' | translate"
                formControlName="occupation"
                [maxLength]="100"
                />
              </div>
            </div>

            <!-- Family Status and Closest Relatives -->
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div
                fxLayout="col"
                fxFlex="50"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Family Status" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
              <div
                fxLayout="col"
                fxFlex="50"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Closest Relatives" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
              <div fxLayout="col" fxFlex="50" class="add-patient-col">
                <nz-select
                  (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                  class="add-patient-inputZorro"
                  nzShowSearch
                  nzAllowClear
                  [nzPlaceHolder]="'Family Status' | translate"
                  formControlName="familyStatusId"
                  >
                  @for (status of familyStatusList; track status) {
                    <nz-option
                      nzLabel="{{ status.name }}"
                      nzValue="{{ status.id }}"
                    ></nz-option>
                  }
                </nz-select>
                <!--
                Conditionally show the free text input.
                The value 6 is the  id of option "Other" in family status
                -->
                @if (personalInfoForm.get('familyStatusId')?.value == 6) {
                  <input
                    class="add-patient-input"
                    formControlName="familyStatusOther"
                    placeholder="{{ 'Please specify' | translate }}"
                    [maxLength]="50"
                    />
                }
              </div>
              <div fxLayout="col" fxFlex="50" class="add-patient-col">
                <nz-select
                  (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                  class="add-patient-inputZorro"
                  nzShowSearch
                  nzAllowClear
                  [nzPlaceHolder]="'Closest Relatives' | translate"
                  formControlName="closestRelativesId"
                  >
                  @for (relative of closestRelativesList; track relative) {
                    <nz-option
                      nzLabel="{{ relative.name }}"
                      nzValue="{{ relative.id }}"
                    ></nz-option>
                  }
                </nz-select>
                <!--
                Conditionally show the free text input.
                The value 7 is the  id of option "Other" in closest relatives
                -->
                @if (personalInfoForm.get('closestRelativesId')?.value == 7) {
                  <input
                    class="add-patient-input"
                    formControlName="closestRelativesOther"
                    placeholder="{{ 'Please specify' | translate }}"
                    [maxLength]="50"
                    />
                }
              </div>
            </div>

            <!-- Amount of Income and Source of Income -->
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div
                fxLayout="col"
                fxFlex="50"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Amount of Income" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
              <div
                fxLayout="col"
                fxFlex="50"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Source of Income" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
              <div fxLayout="col" fxFlex="50" class="add-patient-col">
                <input
                  class="add-patient-input"
                  [placeholder]="'Amount of Income' | translate"
                  formControlName="amountOfIncome"
                  [maxLength]="21"
                  />
                </div>
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  <nz-select
                    (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                    class="add-patient-inputZorro"
                    nzShowSearch
                    nzAllowClear
                    [nzPlaceHolder]="'Source of Income' | translate"
                    formControlName="sourceOfIncomeId"
                    >
                    @for (source of sourceOfIncomeList; track source) {
                      <nz-option
                        nzLabel="{{ source.name }}"
                        nzValue="{{ source.id }}"
                      ></nz-option>
                    }
                  </nz-select>
                </div>
              </div>

              <!-- Date of Admission, Registration Agent  -->
              <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                <div
                  fxLayout="col"
                  fxFlex="33"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                  >
                  {{ "Date of Admission" | translate
                  }}<span class="optional">{{ "(optional)" | translate }}</span>
                </div>
                <div
                  fxLayout="col"
                  fxFlex="33"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                ></div>
                <div
                  fxLayout="col"
                  fxFlex="33"
                  class="add-patient-col"
                  fxLayoutAlign="start center"
                ></div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
                <div fxLayout="col" fxFlex="33" class="add-patient-col">
                  <input
                    class="add-patient-input"
                    [placeholder]="'Date of Admission' | translate"
                    formControlName="dateOfAdmission"
                    type="date"
                    />
                  </div>
                  <div fxLayout="col" fxFlex="33" class="add-patient-col"></div>
                  <div fxLayout="col" fxFlex="33" class="add-patient-col"></div>
                </div>
              </form>
